/**
 * PWA 更新提示条（`05-ui-design-system.md` §5.6 冻结的形态与文案、§6.8 的 testid 表）。
 *
 * 三个冻结面逐字照抄，一个都不许改：
 *   · testid `sw-update-toast`（静态⑮ 按**字面量**判它，改名即红）；
 *   · 文案 `有新版本，点击刷新`；
 *   · 底部常驻黑条 + 白字 + 右侧「刷新」按钮（`min-h-[44px]`，触控下限）。
 *
 * `open === false` 时返回 `null`（**不占屏**）：常驻一条「有新版本」而其实没有，
 * 与没有提示是一样的 —— 店员很快就不再低头看它了。
 */
export interface SwUpdateToastProps {
  open: boolean;
  onRefresh: () => void;
}

export default function SwUpdateToast({ open, onRefresh }: SwUpdateToastProps) {
  if (!open) return null;
  return (
    <div
      data-testid="sw-update-toast"
      className="fixed inset-x-0 bottom-0 z-50 flex items-center justify-between border-t-2 border-black bg-black px-3 py-2 text-sm font-bold text-white"
    >
      <span>有新版本，点击刷新</span>
      <button
        type="button"
        onClick={onRefresh}
        className="min-h-[44px] rounded-lg border-2 border-white px-4 font-bold"
      >
        刷新
      </button>
    </div>
  );
}
